import React, { useEffect, useState } from "react";
import Seo from "../../../shared/ui/Seo";
import { fetchHotdeals } from "../api";
import ProductGrid from "../../products/components/ProductGrid";
import LoadMoreButton from "../../../shared/ui/LoadMoreButton";
import { mergeProducts } from "../../products/utils/productDisplay";
import Loading from "../../../shared/ui/Loading";
import NoResults from "../../../shared/ui/NoResults";
const HotDeals = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const pageSize = 18;

  const fetchProducts = async (page = 0) => {
    setLoading(true);
    try {
      
      const data = await fetchHotdeals(page, pageSize);
      setTotalPages(data.totalPages);
      setProducts((prev) => mergeProducts(prev, data.content, page));
    } catch (error) {
      console.error("Error searching products:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts(currentPage);
  }, [currentPage]);


  if (loading && products.length === 0) {
    return <Loading message="Loading products..." />;
  }
  if (products.length === 0) {
    return <NoResults message="No products found" />;
  }
  return (
    <>
      <Seo
        title="Hot Deals"
        description="Grab today's hot deals on Bigmall: limited-time discounts on electronics, home appliances, beauty and more, with island-wide delivery in Sri Lanka."
      />
    <ProductGrid
      products={products}
      currentPage={currentPage}
      totalPages={totalPages}
      showLoadmore={false}
      title="🔥Hot Deals"
    />
    <div className="container">
        <LoadMoreButton
          hasMore={currentPage < totalPages - 1}
          loading={loading}
          onClick={() => setCurrentPage((page) => page + 1)}
        />
      </div>
    </>
  );
};

export default HotDeals;
